import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'; // 引入创建store 的依赖
import homeIconCourseData from '../pages/home/homeCourseData';
import courseDetailSliceReducer from '@/pages/courseDetail/courseDetailSlice';

export const store = configureStore({
  reducer: {
    homeCourseData: homeIconCourseData,
    detailCourseData: courseDetailSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
